<script lang="ts" setup>
import BadgedAvatar from '@/components/common/avatar/BadgedAvatar.vue'
import { ILeaderboard } from '@/models/Leaderboard'
import { UIAvatar, UITextMdMedium, UITextXsRegular } from '@gohighlevel/ghl-ui'
import { PropType, computed } from 'vue'

const props = defineProps({
  rowItem: {
    type: Object as PropType<ILeaderboard>,
    required: true,
  },
  mobileView: {
    type: Boolean,
    default: true,
  },
})

/**
 *  Computed property to determine the class based on props.mobileView
 *
 *  */
const getClass = computed(() => {
  return props.mobileView
    ? 'grid-auto-cols-4 grid w-full items-center gap-3'
    : 'grid-auto-cols-4 grid cursor-pointer items-center gap-4 pb-2 pl-4 pr-4 pt-2 hover:bg-communities-fill'
})
</script>
<template>
  <div :class="getClass">
    <UIAvatar
      v-if="rowItem['rankIconBackground']"
      :size="26"
      class="!border-none"
      :src="rowItem['rankIconBackground']"
    />
    <UIAvatar v-else :size="26" class="text-communities-font-primary">
      <UITextXsRegular class="text-communities-font-primary">{{
        rowItem.rank
      }}</UITextXsRegular>
    </UIAvatar>
    <BadgedAvatar
      :size="40"
      :avatar-url="rowItem.user.avatar"
      :full-name="rowItem.user.fullName"
      :show-badge="false"
      class="bg-communities-fill"
    />
    <UITextMdMedium class="truncate text-communities-font-primary">
      {{ rowItem.user.fullName }}
    </UITextMdMedium>
    <UITextMdMedium class="text-communities-font-primary">
      +{{ rowItem.totalPoints }}
    </UITextMdMedium>
  </div>
</template>
<style scoped>
.grid-auto-cols-4 {
  grid-template-columns: auto auto 1fr auto;
}
</style>
